/**
* @file 运营中心-公司钱包
* */
<template>
  <div id="organizationFlowing">

    <div class="largeImg" title="单击鼠标左键关闭查看大图" v-if="showImg" @click.stop="showImg = false" style="
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 10000;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
      ">
      <div class="largeImgInner" style="
          width: 80%;
          height: 80%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        ">
        <img :src="imgURL" />
      </div>
    </div>


    <custom-table excel-type="AiRecord" :labelWidth="140" ref="customTable" :customOptions="customOptions"
      :columns="columns" has-organization="true">
      <!-- <template slot="customTable-top">
        <h2 slot="customTable-top" style="padding-bottom: 10px;box-sizing: border-box">
          AI识别余额<span style="color: #ff9900">￥{{ aiBalance || 0 }}</span>
        </h2>
      </template> -->
      <div slot="search-bottom" class="blueInfo">
        <!-- <p>* 纯人像版实名认证(￥1/次)：采集驾驶员面部信息，获得实名认证并存档</p>
        <p>* 证件扩展版实名认证（￥1/次）：对比乘客姓名与身份证号码是否匹配</p>
        <p>* 人脸对比(￥0.004/次)：采集驾驶员面部信息，与实名存档信息对比</p>
        <p>* 身份证识别(￥0.1/次)：自动识别身份证照片中的信息</p> -->
        <p>* AI识别包含：身份证识别、驾驶证识别、行驶证识别、活体验证、 实名验证（2要素）、实名验证（3要素）、背景审核，点击查看<span
            style="color: #409EFF; cursor: pointer;margin-left: 8px;" @click="viewPrice">识别单价</span></p>
      </div>


      <!-- <el-button :loading="loading" slot="search-button-right" @click="AIRechargeClick">充值</el-button> -->

      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime('YYYY-MM-DD HH:mm:SS') }}</template>
        <template v-else-if="item.prop === 'ocrType'">
          {{ new Map([
            [1, '身份证识别'],
            [2, '驾驶证识别'],
            [3, '行驶证识别'],
            [4, '活体验证'],
            [5, '实名验证(2要素)'],
            [6, '实名验证(3要素)'],
            [7, '背景审核'],
          ]).get(row.ocrType), }}
        </template>
        <template v-else-if="item.prop === 'ocrResult'">
          <el-tag size="small" :type="row.ocrResult == 1 ? 'success' : 'danger'">{{ new Map([
            [1, '成功'],
            [2, '失败'],
          ]).get(row.ocrResult), }}</el-tag>
        </template>
        <template v-else>{{ row[item.prop] || row[item.prop] === 0 ? row[item.prop] : '-' }}</template>
      </template>
      <template slot="table-operation">
        <el-table-column label="识别内容" fixed="right" width="100px" v-slot="{ row }">
          <el-button type="text" @click="view(row)">
            <!-- 查看 -->
            识别内容
          </el-button>
        </el-table-column>
      </template>
    </custom-table>

    <!-- 识别单价 -->
    <el-dialog :visible.sync="priceShow" width="800px" title="AI识别场景" :before-close="handleClose">
      <el-table border :data="priceList">
        <el-table-column width="120" prop="ocrType" label="识别类型"></el-table-column>
        <el-table-column width="120" prop="fee" label="识别单价(元/次)"></el-table-column>
        <el-table-column prop="scenarios" label="应用场景"></el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="handleClose">我知道了</el-button>
      </div>
    </el-dialog>
    <!-- 识别内容 -->
    <el-dialog :visible.sync="contentShow" width="500px" title="识别内容" :before-close="contentClose">
      <el-image v-if="content.ocrImg" :src="mixinQiniuImg(content.ocrImg)" :preview-src-list="[mixinQiniuImg(content.ocrImg)]">
      </el-image>
      <div v-if="content.ocrName"><span class="label">姓名</span>{{ content.ocrName }}</div>
      <div v-if="content.ocrIdCard"><span  class="label">身份证号</span>{{ content.ocrIdCard }}</div>
      <div slot="footer">
        <el-button type="primary" @click="contentClose">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- <aliPayDialog ref="aliPayDialog"></aliPayDialog> -->
  </div>
</template>

<script>
import aliPayDialog from '@/components/aliPayDialog.vue'
export default {
  name: "organizationFlowing",
  components: {
    aliPayDialog
  },
  data() {
    return {
      // 配置项
      tableData: [],
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/ai',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          {
            type: "radioGroup",
            field: "timeType",
            name: "时间段",
            value: "0",
            option: [
              { label: '今日', value: "0" },
              { label: '昨日', value: "1" },
              { label: '最近30天', value: "3" },
            ],
          },
          { type: "datetime", field: "time", name: "发送时间", value: [] },
        ]
      },
      // 表头
      columns: [
        { prop: 'created', label: '记录时间' },
        { prop: 'ocrType', label: '识别类型' },
        { prop: 'ocrFee', label: '扣费金额(元)' },
        { prop: 'ocrResult', label: '识别结果' },
        { prop: 'ocrResultMsg', label: '结果说明' },

      ],
      imgURL: "",
      showImg: false,
      // aiBalance: '',
      loading: false,
      priceList: [],
      priceShow: false,
      contentShow: false,
      content: {}
    }
  },
  async created() {
    // this.getAIBalance()
    // this.getPrice()
  },
  methods: {
    // 查看识别单价
    async viewPrice() {
      await this.getPrice()
      this.priceShow = true;
    },
    handleClose() {
      this.priceShow = false;
    },
    // 获取识别单价
    async getPrice() {
      const url = "/api/v1/manage/ai/platform/config";
      let { code, data } = await this.$axios.get(url);
      if (code == 1) {
        this.priceList = [
          {
            ocrType: "身份证识别",
            fee: data.ocrIdCard,
            scenarios: "上传身份证照片，快速获取身份证信息，减少人工录入"
          },
          {
            ocrType: "驾驶证识别",
            fee: data.ocrDriverLicense,
            scenarios: "上传驾驶证照片，快速获取驾驶证信息，减少人工录入"
          },
          {
            ocrType: "行驶证识别",
            fee: data.ocrVehicleLicense,
            scenarios: "上传行驶证照片，快速获取行驶证信息，减少人工录入"
          },
          {
            ocrType: "活体检测",
            fee: data.verifyBody,
            scenarios: "采集用户的人脸信息，确保人证合一，与实名验证搭配使用"
          },
          {
            ocrType: "实名认证(2要素)",
            fee: data.verifyIdCard,
            scenarios: "核验司机、乘客的姓名、身份证号码是否匹配，确保人证合一"
          },
          {
            ocrType: "实名认证(3要素)",
            fee: data.verifyFace,
            scenarios: "核验司机、乘客的姓名、身份证号码及人脸是否匹配，确保人证合一"
          },
          {
            ocrType: "背景审核",
            fee: data.verifyAdverseRecord,
            scenarios: "核验司机是否有过违法犯罪情况"
          },
        ]
      }
    },
    // async getAIBalance() {
    //   let url = "/api/v1/manage/ai/count";
    //   let res = await this.$axios.get(url);
    //   if (res && res.code === 1) {
    //     this.aiBalance = res.data.balance;
    //   }
    // },
    async view(row) {
      this.content = row;
      this.contentShow = true;
    },
    contentClose(){
      this.contentShow = false;
    },
    /* 第三方AI识别token */
    async getAIToken() {
      let url = "/api/v1/manage/ai/token";
      let res = await this.$axios.get(url);
      if (res && res.code === 1) {
        return res.data;
      }
    },
    /* 第三方AI识别充值 */
    async AIRechargeClick() {
      this.$refs.aliPayDialog.rechargeOpen()
      // this.loading = true;
      // let token = await this.getAIToken();
      // let url =
      //   `https://manage.rvaka.com/#/recharge?companyId=${this.mixinUserInfo.organizationId}&rechargeSource=passengerTransport&type=busAi&authorization=${token}`;
      // window.open(url);
      // this.loading = false;
    },


  }
}
</script>

<style scoped lang="less">
.organizationFlowing {
  #printJS-form {
    background-color: white;
    top: -1100px;
    width: 1400px;
    position: fixed;
    z-index: -10
  }
}
  .label{
    display: inline-block;
    width: 100px;
  }
</style>
